import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { for: "image_uploads" }
const _hoisted_2 = {
  type: "button",
  class: "group mt-1.5 bg-white inline-flex items-center px-4 py-2 border border-gray-200 hover:border-gray-200 shadow-sm rounded-md hover:bg-gray-200 cursor-pointer transition duration-500 ease-in-out focus:outline-none transform"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "-ml-2 mr-1 h-5 w-5 text-gray-400 group-hover:text-gray-500",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_4 = { class: "font-roboto text-sm font-normal text-gray-500 group-hover:text-gray-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.haveLogo ? 'Muuda logo' : 'Lisa logo'), 1)
      ])
    ]),
    _createElementVNode("input", {
      type: "file",
      id: "image_uploads",
      name: "image_uploads",
      accept: "image/*",
      class: "opacity-0",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLogoSelected && _ctx.onLogoSelected(...args)))
    }, null, 32)
  ]))
}